import {Divider, PasswordInput, Input, Button, Title} from "@mantine/core";
import React, {useState, useRef} from "react";
import Turnstile from "react-turnstile";
import {Link} from "react-router-dom";
import { IconLock, IconAt } from '@tabler/icons-react';

import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Footer} from "../../components/GetFooter";
import {FormContainer} from "../../components/form/FormContainer";

import {loginForm} from "../../logic/forms/LoginForm";
import {updateSubmit} from "../../logic/UpdateSubmit";
import {LoginFormModel} from "../../models/forms/LoginFormModel";

async function LoginSubmit (body: LoginFormModel) {
    // Clear notification banner and set button to loading state
    updateSubmit(body.submitButton, 'Authenticating', true);
    body.setBanner(<></>)

    await loginForm(body);
    updateSubmit(body.submitButton, 'Login', false);
}

export function Login({memory}: SystemMemoryProps) {
    const inputs = {
        email: useRef(null),
        password: useRef(null),
        cfTurnstileToken: useRef("null")
    }

    // Create navigation and notification states
    const [notification, setNotification] = useState(<></>)

    // Check if the user is already logged in, if so redirect to the dashboard
    if (memory[0].isSignedIn) {
        memory[0].Router('/account/dashboard');
    }

    // Create submit button state with the submit button within it
    const submit = useState(
        <Button variant="light" color="indigo" radius="md" size="md" uppercase
                onClick={() => LoginSubmit({
                    memory: {memory},
                    setBanner: setNotification,
                    submitButton: submit,
                    inputs: inputs
                })}>
            Login
        </Button>
    );

    // Create the login form
    const form = (
        <>
            {notification}<br/>
            <Title align="center">Login</Title>
            <Input.Label required size={"lg"}>Email Address</Input.Label>
            <Input
                placeholder="Your account's email"
                icon={<IconAt size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.email}
            /><br/>
            <Input.Label required size={"lg"}>Password</Input.Label>
            <PasswordInput
            placeholder="Password"
            icon={<IconLock size={"1rem"}/>}
            variant="filled"
            radius="md"
            size="lg"
            ref={inputs.password}
            /><br/>
            <center>
                <Turnstile
                    sitekey={memory[0].CFSiteKey}
                    onVerify={(token) => {
                        inputs.cfTurnstileToken.current = token
                    }}/><br/>
                {submit[0]}
            </center>
            <br/><Divider size={2}></Divider><br/>
            <Link style={{textDecoration: 'none'}} to='/verify'><Button variant="subtle" color="indigo">Verify Account</Button></Link>
            <Button variant="subtle" color="indigo">Forgot Password</Button>
        </>
    )

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            {FormContainer(form)}
            <Footer data={[]}></Footer>
        </>
    )
}